export default __webpack_public_path__ + "static/media/like.6144e6d3.png";